"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.search.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _user = require("@/api/user");
var _loop = require("@/api/loop");
var _utils = require("@/utils");
var _autoTableHeight = require("@/views/mixins/autoTableHeight");
var _index = _interopRequireDefault(require("../../../components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LoopIndex',
  components: {
    SearchBox: _index.default
  },
  filters: {
    getInternalTitle: function getInternalTitle(value) {
      return typeof value === 'undefined' ? '' : value.title;
    },
    getTenantLabel: _utils.getTenantLabel,
    getProducerStaff: function getProducerStaff(value, staffList) {
      var plist = _lodash.default.map(_lodash.default.flatten(_lodash.default.map(_lodash.default.filter(value, {
        role: 'manager'
      }), function (p) {
        return _lodash.default.filter(staffList, {
          user: p.user
        });
      })), function (n) {
        return n.name;
      }).toString();
      return plist;
    }
  },
  mixins: [_autoTableHeight.autoTableHeight],
  data: function data() {
    return {
      tableLoading: false,
      copyDrawer: false,
      total: 0,
      trainingStatus: _lifehikesInitData.trainingStatus,
      loopList: [],
      staffList: [],
      query: {
        page: 1,
        limit: 50,
        sort: '-start.utc',
        q: undefined,
        publish: undefined,
        staffUuid: undefined,
        staffRole: undefined
      },
      checked: {
        drawTitle: '',
        id: '',
        genneralInfo: true,
        salesForce: true,
        eventTime: true,
        welcomeResourceSetting: true,
        programs: true,
        staffs: true,
        emailSettings: true
      }
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.getStaffList();
          case 1:
            _context.n = 2;
            return _this.getList();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    checkPermission: _permission.default,
    search: function search(pageNo) {
      this.query.page = pageNo;
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      this.query.publish = this.query.publish === '' ? undefined : this.query.publish;
      this.getList();
    },
    deleteLoop: function deleteLoop(id, title) {
      var _this2 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var oEmail = (0, _cookie.getCookie)('EMAIL');
      var updatedPublishStatus = {
        id: id,
        publish: 'markdelete'
      };
      this.$confirm("This will delete [ ".concat(title, " ]. Continue?"), 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        var data = {
          publish: 'markdelete'
        };
        (0, _loop.updateLoopById)(token, id, data).then(function (response) {
          _this2.search(_this2.query.page);
          var msg = 'Loop is deleted';
          (0, _log.displayPopupMessage)(msg, 'success');
          (0, _ga.writeGaEvent)(_this2, 'Loop', "".concat(_lifehikesInitData.userEvent.loop.delete), oEmail, "Loop Id: ".concat(id));
        }).catch(function (error) {
          (0, _log.displayPopupMessage)(error, 'error');
        });
      }).catch(function () {
        var msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    getList: function getList() {
      var _this3 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      // Open loading after API interconnection
      // this.tableLoading = true

      (0, _log.showDebugLog)('Loop query', this.query);
      (0, _loop.getLoopList)(token, this.query).then(function (response) {
        (0, _log.showDebugLog)('Loop-Search-response', response);
        _this3.loopList = response.data.rows;
        _this3.total = response.data.count;
        _this3.tableLoading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('loop-Search-error', error);
        _this3.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response })
      });
    },
    getStaffList: function getStaffList() {
      var _this4 = this;
      this.loading = true;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var query = {
        page: 1,
        limit: 100,
        role: 'otr-digital-producer',
        sort: 'givenName'
        // timestamp:new Date().getTime()
      };
      (0, _user.getUserList)(token, query).then(function (response) {
        _this4.loading = false;
        _this4.staffList = response.data.rows.map(function (s) {
          return {
            user: s.uuid,
            name: "".concat(s.givenName, " ").concat(s.familyName)
          };
        });

        // console.log('Staff List', this.staffList)
      }).catch(function (error) {
        _this4.loading = false;
        (0, _log.showDebugLog)('GetUserList-api-error', error);
      });
    },
    setMyTraining: function setMyTraining() {
      if (this.query.staffUuid) {
        this.query.staffRole = 'producer';
        // this.query.staffUuid = uuid
      } else {
        this.query.staffRole = undefined;
        this.query.staffUuid = undefined;
      }
    },
    isExipred: function isExipred(endUtc) {
      var now = _moment.default.utc();
      var end = _moment.default.utc(endUtc);
      return now > end;
    },
    sort: function sort(data) {
      var prop = data.prop,
        order = data.order;
      if (prop === 'title') {
        order === 'ascending' ? this.query.sort = '+title' : this.query.sort = '-title';
      }
      if (prop === 'start') {
        order === 'ascending' ? this.query.sort = '+start.utc' : this.query.sort = '-start.utc';
      }
      if (prop === 'end') {
        order === 'ascending' ? this.query.sort = '+end.utc' : this.query.sort = '-end.utc';
      }
      if (prop === 'description') {
        order === 'ascending' ? this.query.sort = '+description' : this.query.sort = '-description';
      }
      if (prop === 'publish') {
        order === 'ascending' ? this.query.sort = '+publish' : this.query.sort = '-publish';
      }
      if (prop === 'updatedAt') {
        order === 'ascending' ? this.query.sort = '+updatedAt' : this.query.sort = '-updatedAt';
      }
      if (prop === 'internal.title') {
        order === 'ascending' ? this.query.sort = '+internal.title' : this.query.sort = '-internal.title';
      }
      if (prop === 'internal.opportunityNumber') {
        order === 'ascending' ? this.query.sort = '+internal.opportunityNumber' : this.query.sort = '-internal.opportunityNumber';
      }
      if (prop === 'type') {
        order === 'ascending' ? this.query.sort = '+type' : this.query.sort = '-type';
      }
      this.search(1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    disableVisble: function disableVisble(id) {
      // console.info(this.$refs[id]);
      this.$refs[id].visible = false;
    },
    handleDrawClose: function handleDrawClose(done) {
      this.$confirm('Are you sure you want to stop copy?').then(function (_) {
        done();
      }).catch(function (_) {});
    },
    openDrawer: function openDrawer(id, title) {
      this.copyDrawer = true;
      this.checked.drawTitle = "Copy a New Loop from [".concat(title, " (").concat(id, ")]");
      this.checked.id = id;
    },
    copy: function copy() {
      this.copyDrawer = false;
      var link = "/loop/createfromcopy?" + "fromId=".concat(this.checked.id, "&") + "gi=".concat(this.checked.genneralInfo, "&") + "sf=".concat(this.checked.salesForce, "&") + "et=".concat(this.checked.eventTime, "&") + "wrs=".concat(this.checked.welcomeResourceSetting, "&") + "p=".concat(this.checked.programs, "&") + "s=".concat(this.checked.staffs, "&") + "es=".concat(this.checked.emailSettings);
      this.$router.push(link);
    }
  }
};